import styled from 'styled-components'

export const Text = styled.div<{ mt?: number; mb?: number; fs?: number; fw?: number; textAlign?: 'center' }>`
  margin-top: ${(props) => props.mt}px;
  margin-bottom: ${(props) => props.mb}px;
  font-size: ${(props) => props.fs}px;
  font-weight: ${(props) => props.fw};
  text-align: ${(props) => props.textAlign};
`
